// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1PBjM","row":"ProcedureTreatmentSummary_row__3qJFs"};